import React from 'react';
import { Box, Typography } from '@mui/material';
import { useWatch } from 'react-hook-form';
import { FormFieldGroup, FormFieldLabel } from './EnterSaleInfoModalStyled';

export const REGISTER_TYPE = { NEW: 'NEW', RE: 'RE' };

const OPTIONS = [
  { value: REGISTER_TYPE.NEW, title: '신규등록', caption: '처음 구매하는 회원' },
  { value: REGISTER_TYPE.RE, title: '재등록', caption: '센터 상품 재구매 회원' },
];

/**
 * 신규등록 / 재등록 이지선다(#124) — 라디오 카드 2개(사용자 시안 2026-09-16).
 * 값 계약 — 폼 필드 `registerType` = 'NEW' | 'RE'. 서버는 고른 값을 주문별로 저장하고 매출 신규/재등록 표시·필터·집계에 쓴다.
 */
const RegisterTypeToggle = ({ control, setValue, name = 'registerType', readOnly = false, sx }) => {
  const value = useWatch({ control, name });
  const pick = next => {
    if (!readOnly) setValue(name, next, { shouldDirty: true });
  };
  return (
    <FormFieldGroup sx={sx}>
      <FormFieldLabel>등록 구분</FormFieldLabel>
      <Box sx={{ display: 'flex', gap: '12px' }}>
        {OPTIONS.map(option => {
          const active = value === option.value;
          return (
            <Box
              key={option.value}
              onClick={() => pick(option.value)}
              sx={{
                flex: 1,
                minWidth: 0,
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                padding: '12px 14px',
                border: active ? '1.5px solid #4AB3BC' : '1px solid #D9D9D9',
                borderRadius: '8px',
                backgroundColor: active ? '#F3F9FA' : '#fff',
                cursor: readOnly ? 'default' : 'pointer',
                transition: 'all 0.15s ease',
                '&:hover': readOnly ? undefined : { borderColor: '#4AB3BC' },
              }}>
              {/* 라디오 */}
              <Box
                sx={{
                  width: '18px',
                  height: '18px',
                  borderRadius: '50%',
                  border: active ? '5px solid #4AB3BC' : '1.5px solid #c4c4c4',
                  backgroundColor: '#fff',
                  boxSizing: 'border-box',
                  flexShrink: 0,
                  transition: 'all 0.15s ease',
                }}
              />
              <Box sx={{ minWidth: 0 }}>
                <Typography sx={{ fontSize: '14px', fontWeight: 700, color: '#222', lineHeight: 1.3 }}>{option.title}</Typography>
                <Typography sx={{ fontSize: '12px', color: '#737373', lineHeight: 1.3, mt: '2px', whiteSpace: 'nowrap' }}>
                  {option.caption}
                </Typography>
              </Box>
            </Box>
          );
        })}
      </Box>
    </FormFieldGroup>
  );
};

export default RegisterTypeToggle;
